import { Title } from '../../utils/title';
import Layout from './Layout';
import styles from './Terms.module.scss';

const Terms = () => {
  return (
    <Layout>
      <div className={styles.root}>

        <Title value='Terms of Use' />

        {
          /*
           * BEGIN HTML
           */
        }
        <div className="d-flex justify-content-center align-items-center">
          <h1 className="card-title text-muted text-black">TERMS OF USE</h1>
        </div>
        <p className="card-text">
          Please read the following Terms and Conditions (these “Terms”) carefully before using
          the Chimaeable (“Chimeable,” “we,” “our,” or “us”) website located at
          https://www.chimeable.com/, or participating in the use of this website/mobile
          application or any online features, application, products, services and/or programs
          offered by us (collectively, the “Services”). These Terms apply to use of the Services.
        </p>
        <p className="card-text font-weight-bold">
          <strong>
            These Terms include important information about your legal rights, remedies, and
            obligations, including various limitations and exclusions, and provisions that govern
            the procedure, jurisdiction and venue of any disputes. By accessing or using the
            Services, you are entering into a legal contract with us regarding your use of the
            Services. You agree to be bound by these Terms and all additional terms incorporated
            by reference, including the arbitration provision set forth in these Terms. If you do
            not agree to these Terms, you should delete the Services from your device and not
            access or otherwise use the Services. Your continued use of the Services signifies
            your acceptance of the Terms.
          </strong>
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">1.How The Services Works</h2>
        <p className="card-text">
          By using the Services, you may take part in content creation campaigns on our platform.
          By creating a profile and sharing your social media accounts with Chimeable, you may
          receive digital offers or physical products, in exchange for your product review in
          various forms like video, image or text.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">
          2.License to use the Services
        </h2>
        <h3 className="text-muted text-black">a. Use of the Services</h3>
        <p className="card-text">
          Subject to these Terms, we hereby grant you a non-transferable, non-exclusive, limited
          license to use and access the Services for your personal use. By merely providing you
          access to, and use of, the Services, we do not warrant or represent that:
          <ul>
            <li>
              any statement, documents, images, graphics, logos, designs, information, review,
              audio, video, or any other information provided from or on the Services
              (collectively, the “Content”) is accurate or complete;
            </li>
            <li>the Content is up-to-date or current;</li>
            <li>we have any obligation to update any Content;</li>
            <li>
              the Content is free from technical inaccuracies or programming or typographical
              errors;
            </li>
            <li>the Content is free from changes made by third parties;</li>
            <li>
              your access to the Services will be free from interruptions, errors, computer
              viruses or other harmful components; and/or
            </li>
            <li>
              any information obtained in response to comments or questions asked through the
              Services is or will be accurate or complete.
            </li>
          </ul>
        </p>
        <h3 className="text-muted text-black">b. Restrictions on Use. You may not:</h3>
        <ul>
          <li>
            remove or obscure any copyright, trademark, digital watermarks, proprietary legends or
            other proprietary notices from any portion of the Service or any Content contained
            therein;
          </li>
          <li>
            reproduce, modify, prepare derivative works based upon, distribute, license, lease,
            sell, resell, transfer, publicly display, publicly perform, transmit, stream,
            broadcast or otherwise exploit the Services, or any aspect of them, except as
            expressly permitted by us;
          </li>
          <li>
            decompile, reverse engineer, jeopardize the correct functioning of the Services, or
            disassemble the Services, or otherwise attempt to derive the source code of the
            software (including the tools, processes, methods, and infrastructure) that enables or
            underlies the Services, except as may be permitted by applicable law;
          </li>
          <li>
            cause or launch any programs, spiders, robots, or scripts or other automatic or manual
            devices or processes for the purpose of extracting, scraping, indexing, surveying, or
            otherwise data mining any portion of the Services, or unduly burdening or hindering
            the operation and/or functionality of any aspect of the Services;
          </li>
          <li>
            attempt to gain unauthorized access to or impair any aspect of the Services, or the
            related systems, servers, or networks;
          </li>
          <li>
            use the Services to stalk, harass or harm another individual, or in any way that is in
            violation of any law or regulation;
          </li>
          <li>
            impersonate any person or entity, or otherwise misrepresent your affiliation with any
            person or entity;{' '}
          </li>
          <li>
            use any portion of the Services or any Content in any manner that may give a false or
            misleading impression, attribution or statement as to us or any other person or
            entity;
          </li>
          <li>
            Use the Services to promote violence, degradation, subjugation, discrimination or
            hatred against individuals or groups based on race, color, ethnicity, national origin,
            age, gender, gender identity, gender expression, sexual orientation, disability,
            physical appearance, body size, or religion; or
          </li>
          <li>
            Use the Services for any unlawful activities or in violation of any laws, regulations,
            or contractual provisions, or to induce others to do or engage in the same;{' '}
          </li>
          <li>
            Use or uploading content that is defamatory, libelous, hateful, violent, obscene,
            pornographic, invasive of another’s privacy, infringing of another’s intellectual
            property rights, unlawful, or otherwise offensive, as determined by Chimeable in its
            sole discretion.
          </li>
        </ul>
        <h3 className="text-muted text-black">Ownership of the Services and Content. </h3>
        <p>
          The ownership of the Services, Content, and all rights therein are and will remain with
          Chimeable. You may view, copy or print a single copy of any page from the Services for
          personal, non-commercial use if you do not remove, modify, or alter any copyright or
          proprietary rights notices that may be present. You may not otherwise use, modify, copy,
          print, display, distribute, publish, or sell any information, images, Content, that you
          obtain from the Services without our express, prior, written consent. Any special rules
          for any software, downloads, or other items accessible through the Services may be
          included elsewhere in the Services and are incorporated into these Terms by reference.{' '}
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">3. User Content Policy. </h2>
        <ul>
          <li>
            The Services may now or in the future permit you to upload or post to the Services or
            otherwise submit to Chimeable various forms of content, such as statements, reviews,
            ratings, opinions, information, text, graphics, questions, suggestions, messages,
            comments, feedback, ideas, notes, drawings, articles, stories about you, or any other
            content of any kind whatsoever that you publish to the Services (collectively, “User
            Content”).{' '}
          </li>
          <li>
            You warrant to Chimeable that you own all rights in your User Content or all
            third-party holders of rights in your User Content have validly and irrevocably
            granted to you the right to grant the rights and licenses set forth above. By
            submitting any User Content in any form to Chimeable, in addition to other provisions
            of these Terms, you automatically grant Chimeable, its parent companies, subsidiaries,
            affiliates, successors and assigns, a perpetual, irrevocable, royalty-free, worldwide,
            non-exclusive, sublicensable and assignable right and license to use, copy, reproduce,
            modify, adapt, publish, edit, translate, create derivative works from, transmit,
            distribute, and/or display such User Content, without further notice to you, or
            consent from you, and without any requirement to pay anything to you or anyone else.{' '}
          </li>
          <li>
            We reserve the right, in our sole discretion, to review and approve User Content
            before or after it is made available to other users of the Services. Please remember
            that, even if we review your User Content, you will be solely responsible for your
            User Content and the consequences of posting or publishing it. We do not endorse any
            User Content or any opinion, recommendation, or advice expressed on or through the
            Services, and we expressly disclaim any and all liability in connection with User
            Content. You acknowledge that Chimeable, our site moderators (if any) and our agents
            reserve the right, in our sole discretion, to refuse, move, and/or remove User Content
            available on or through the Services that, in our judgment, does not comply with these
            Terms and any other rules of user conduct applicable to our Services, or is otherwise
            harmful, objectionable, or inaccurate. We are not responsible for any failure or delay
            in removing such User Content. You represent and warrant that neither your User
            Content nor your uploading, publishing or otherwise making available your User Content
            nor Chimeable’s use of your User Content as permitted herein will infringe,
            misappropriate or violate a third party’s intellectual property or proprietary rights,
            or rights of publicity or privacy, or result in the violation of any applicable law or
            regulation.{' '}
          </li>
        </ul>
        <h2 className="card-subtitle mb-2 text-muted text-black">4.Updates</h2>
        <p>
          We may make changes to the Services, the Content, the User Content and/or these Terms or
          stop providing any of the Services and/or the Content at any time and without further
          notice to you. We will make an effort to update the Services with any changes to these
          Terms, and you are encouraged to review these Terms frequently (the date of the most
          recent revision to these Terms appears at the end of these Terms). Your continued access
          or use of the Services after such posting constitutes your consent to be bound by the
          Terms, as amended.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">
          5.Privacy and Electronic Communication.{' '}
        </h2>
        <p>
          We know that privacy is very important to you, and it is very important to us as well.
          Personal data that you provide regarding yourself will be handled in accordance with our
          Privacy Policy located at https://www.chimeable.com/privacy-policy. By using the
          Services, you consent to receive electronic communications from us unless you follow
          applicable opt-out procedures. We will communicate with you by email or by posting
          notices on our Services. You agree that all agreements, notices, disclosures and other
          communications that we provide to you electronically satisfy any legal requirement that
          such communication be in writing.{' '}
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">
          6.User Account, Password and Security.{' '}
        </h2>
        <p>
          {' '}
          To the extent that a user account is created by you to access and use the Services
          (“User Account”), the following will apply:
        </p>
        <ul>
          <li>
            <strong>User Account:</strong> To access certain features, Content and/or User Content
            available through the Services, we may require that you sign up for an account that
            you can link to the Services or by using your first name, last name, email address and
            a password to create a User Account and profile about you (a “Profile”). If you do not
            create a User Account and Profile, you may not have access to certain functionality of
            the Services. We use reasonable precautions to protect the privacy of your username,
            password, and User Account information. You, however, are ultimately responsible for
            protecting your username, password, and User Account information from disclosure to
            third parties. You agree to: (i) immediately notify us of any unauthorized use of your
            username, password, or User Account, or any other breach of security; (ii) ensure that
            you exit from your User Account at the end of each session; and (iii) use a security
            passcode to secure your device where your User Account information is stored. While we
            may provide certain encryption technologies and use other reasonable precautions to
            protect your confidential information and provide suitable security, we do not and
            cannot guarantee or warrant that information transmitted through the Internet or other
            wireless connections, is secure, or that such transmissions are free from delay,
            interruption, interception or error.{' '}
          </li>
          <li>
            <strong>Accurate Information :</strong> In creating and using your User Account and
            Profile, you agree to: (i) provide true, accurate, current, and complete information
            about yourself on any registration form required for the Services, including, but not
            limited to, your full name and email address (such information being the “Registration
            Data”); and (ii) maintain and promptly update the Registration Data to keep it true,
            accurate, current, and complete. If you provide any information that is untrue,
            inaccurate, not current, or incomplete, or if we have reasonable grounds to suspect
            that such information is untrue, inaccurate, not current, or incomplete, then we have
            the right to suspend or terminate your User Account and refuse any and all current or
            future use of your User Account.{' '}
          </li>
          <li>
            <strong>Non-Transferability of User Account:</strong>
            Each user is only permitted to have one User Account. User Accounts and usernames are
            non-transferable, and all users are obligated to take preventative measures to
            prohibit unauthorized users from accessing the Services with his or her username and
            password. You agree that you are solely responsible for activity that occurs under
            your User Account. We are entitled to act on all instructions received by anyone using
            your User Account, and we reserve the right to pursue any and all claims against any
            user of your User Account.
          </li>
          <li>
            <strong>Account Deactivation:</strong>We reserve the right to deactivate or cancel a
            User Account in our sole discretion, including for the following reasons: (i) you
            request such deactivation; (ii) you are deceased; (iii) you do not respond to repeated
            communication attempts regarding the status of your User Account; (iv) you fail to
            make payments related to your User Account (if applicable); (v) you reside in or
            relocate to a country where use of a User Account is prohibited under applicable law;
            (vi) you act in a fraudulent or an inappropriate manner while using the User Account;
            and/or (vii) for any reason, or no reason, as determined by Chimeable. You will be
            responsible for all charges incurred up until the time the account is deactivated, if
            applicable.
          </li>
        </ul>
        <h2 className="card-subtitle mb-2 text-muted text-black">7.Objectionable Material.</h2>
        <p>
          You acknowledge that, in using the Services and accessing the Content and/or the User
          Content, you may encounter material that you deem to be disturbing, offensive or
          objectionable.
          <strong>
            {' '}
            You agree to use the Services at your sole risk and that Chimeable will have no
            liability to you for material that may be disturbing, objectionable or offensive to
            you.
          </strong>{' '}
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">
          8.Not Intended for Children and Other Age Requirements..
        </h2>
        <p>
          The Services are not intended or designed to attract children under the age of eighteen
          (18). By using the Services and agreeing to these Terms, you affirm that you are more
          than eighteen (18) years of age, or are an emancipated minor, and are fully able and
          competent to enter into the terms, conditions, obligations, affirmations,
          representations, and warranties set forth in these Terms, and to abide by and comply
          with these Terms.{' '}
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">9.Point Usage Terms.</h2>
        <ul>
          <li>
            Point Usage Terms Non-Monetary Value: The points earned through the completion of
            activities on our website ("Points") are purely for the site's engagement purposes.
            They hold no monetary value and cannot be exchanged, refunded, or redeemed for cash.
          </li>
          <li>
            No Guaranteed Entitlement: Accumulation of Points does not guarantee or entitle
            members to any free products or services.{' '}
          </li>
          <li>
            Campaign Participation: Points may be used solely to opt-in to specific campaigns
            ("Campaigns") for which a member has received a direct invitation from us. The number
            of Points required for participation in any Campaign may vary and will be specified
            within the invitation to that specific Campaign.
          </li>
          <li>
            Adjustments to Points Balance: We reserve the right to increase, decrease, or remove
            Points from any member's account at any time without prior notification. This can be
            done at our sole discretion and may be a result of periodic system updates, detected
            irregularities, or adjustments in our Points policy.{' '}
          </li>
          <li>
            Earning Points: Points can be earned by participating in various activities on our
            site as defined by our ongoing engagement programs. The activities eligible for
            earning Points, along with the number of Points awarded for each activity, are subject
            to change without prior notice.{' '}
          </li>
          <li>
            Expiration of Points: Points may expire, and it is the responsibility of the member to
            monitor their Points balance and any associated expiration dates. Expired Points will
            not be reinstated.{' '}
          </li>
          <li>
            Non-Transferable: Points are non-transferable and are tied to the member's account.
            They cannot be shared with or transferred to other users or accounts.{' '}
          </li>
          <li>
            Changes to Terms: The terms related to Points, including but not limited to their
            usage, accumulation, and redemption, may be modified by us at any time without prior
            notice. Continued use of the site and participation in the Points system constitutes
            acceptance of these terms.{' '}
          </li>
          <li>
            By engaging with our site and opting to earn and use Points, members acknowledge and
            agree to these terms.
          </li>
        </ul>
        <h2 className="card-subtitle mb-2 text-muted text-black">10.CASH REWARDS GENERALLY</h2>
        <p>
          We may provide opportunities for you to participate in cash reward campaigns in exchange
          for activities such as purchasing specific products, creating content, or sharing
          content. By participating in these campaigns, you will earn cash rewards, which will be
          credited to your Chimeable account ("Cash Rewards") upon approval of your activity for
          compliance with correctness and quality standards.
        </p>
        <p>
          Each campaign with cash rewards may be subject to Additional Terms and may be
          discontinued by Chimeable at any time without notice. At any time, and at our sole
          discretion, we may: (i) limit the number of campaigns; (ii) determine whether or not you
          are eligible to participate in a campaign with cash rewards; (iii) determine whether or
          not you have earned Cash Rewards; or (iv) adjust your Cash Rewards total to accurately
          reflect what you have actually earned. We may, in our sole discretion, deduct from your
          account any Cash Rewards that we determine you have not earned or have earned in
          violation of these Terms. Cash rewards are contingent upon an approval process, which is
          based on meeting the requirements outlined in the campaign details.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">
          a. Rewards Redemptions and Minimum Cash Rewards Level
        </h4>
        <p>
          Once your Cash Rewards account has accumulated a minimum balance of Ten Dollars
          ($10.00), we will process the distribution to your designated account within 30 days of
          reaching the minimum balance. We also reserve the right to issue payments before the
          minimum balance is reached at our sole discretion.
        </p>
        <p>
          The available distribution options are subject to change without notice to you, and you
          have no vested right to any particular form or method of distribution. You may not
          receive any Cash Rewards, and you may not obtain any cash, money, or anything of value
          in exchange for your Cash Rewards prior to reaching the Minimum Distribution Amount or
          if your Cash Rewards subsequently fall below the Minimum Distribution Amount. For each
          distribution option made available by Chimeable to you through the Services, we will
          display the Minimum Distribution Amount, and that Minimum Distribution Amount will
          apply. We may, at our sole discretion, limit the amount of Cash Rewards that you can
          distribute in any given period or transaction.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">
          b. Third-Party Payment Providers and Cash Rewards Distribution
        </h4>
        <p>
          Cash Rewards distributions may be facilitated by third-party licensed payment providers,
          such as PayPal, or other money transmitters. The distribution of Cash Rewards through
          these providers will be subject to their respective terms and conditions. By opting to
          receive your Cash Rewards through any of these third-party services, you agree to comply
          with the applicable terms, which may be modified by the payment provider from time to
          time.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">c. Taxes and Fees</h4>
        <p>
          You are responsible for any tax liabilities that arise from your receipt of Cash
          Rewards. We may deduct applicable taxes from your Cash Rewards or require additional
          information to ensure compliance with tax regulations.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">d. Account Maintenance Fees</h4>
        <p>
          If you do not redeem Offers or earn Referral Bonuses for a period of 180 days, we may
          deduct an account maintenance fee from your Cash Rewards balance, up to $3.99 USD per
          month. If your account balance reaches zero, no further fees will be deducted. We will
          notify you of any changes to this fee.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">
          e. Unclaimed Cash Rewards and Escheatment
        </h4>
        <p>
          If your account remains inactive and unclaimed for a legally specified period,
          applicable under state laws, your Cash Rewards may be subject to escheatment and
          transferred to your state's department of revenue. We will not be liable for any loss of
          Cash Rewards as a result of escheatment.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">f. Claims</h4>
        <p>
          Cash Rewards provided through our platform are solely from us and not underwritten or
          guaranteed by third parties. You agree not to make claims for Cash Rewards against
          third-party merchants, providers, or manufacturers.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">g. Prohibited Conduct</h4>
        <p>By using our services, you agree not to:</p>
        <ul>
          <li>
            Submit false, inaccurate, fabricated, or tampered information, such as purchase data,
            for the purpose of claiming Cash Rewards.
          </li>
          <li>
            Redeem, or attempt to redeem, Cash Rewards for products that have not actually been
            purchased or have been purchased and subsequently returned to a store or vendor.
          </li>
          <li>
            Upload receipts that have already been submitted by you or another user, or receipts
            for products you did not actually purchase, to claim Cash Rewards.
          </li>
          <li>
            Upload receipts that reflect purchases made more than one (1) week before submission.
          </li>
          <li>
            Upload receipts for purchases made before the launch of a campaign unless specifically
            allowed by the campaign’s terms.
          </li>
          <li>
            Attempt to alter or obscure information on a receipt, such as uploading a receipt with
            an illegible date.
          </li>
          <li>
            Extract data from our web or mobile platforms to use with or for another service, web,
            or mobile application.
          </li>
          <li>
            Rent, lease, loan, sell, resell, sublicense, distribute, or otherwise transfer
            licenses granted herein or any related materials.
          </li>
          <li>
            Post, upload, or distribute defamatory, inaccurate, unlawful, offensive, indecent, or
            otherwise inappropriate content.
          </li>
          <li>
            Misuse or attempt to misuse our referral or reward programs, such as inviting yourself
            or creating multiple accounts to exploit rewards.
          </li>
          <li>Make false or misleading claims about any incentive programs we offer.</li>
          <li>
            Impersonate any person or entity, falsely claim affiliation with someone, access
            another's account without permission, or engage in any fraudulent activities.
          </li>
          <li>
            Violate any intellectual property rights of others, including unauthorized use of
            trademarks, copyrights, or other proprietary materials.
          </li>
          <li>
            Use someone else's content—such as product reviews, images, or videos—without proper
            authorization or attribution, for the purpose of fulfilling campaign requirements or
            gaining rewards.
          </li>
          <li>
            Send unsolicited offers, advertisements, or spam to other users, including promotional
            or solicitation material, chain mail, or petitions.
          </li>
          <li>Use the Services for illegal purposes or in violation of any laws.</li>
          <li>
            Harass, defame, abuse, threaten, or defraud other users or collect their personal
            information without consent.
          </li>
          <li>Use the Services for commercial purposes without authorization</li>
          <li>
            Interfere with security features of the Services, such as removing, disabling, or
            damaging features that prevent or restrict access to content.
          </li>
          <li>
            Reverse engineer, decompile, or disassemble the Services unless expressly permitted by
            applicable law.
          </li>
          <li>
            Modify, adapt, or create derivative works based on the Services, unless permitted by
            law.
          </li>
          <li>
            Intentionally disrupt or damage the operation of the Services, including through the
            use of malicious code like viruses, spyware, or worms.
          </li>
          <li>Use automated or programmatic means to interact with the Services.</li>
          <li>
            Use or attempt to use the Services outside of authorized geographic regions, such as
            the United States.
          </li>
        </ul>

        <h2 className="card-subtitle mb-2 text-muted text-black">
          11.DISCLAIMERS & INDEMNIFICATION.
        </h2>
        <ul>
          <li>
            <strong>No Warranties for Services.:</strong> When using the Services, information
            will be transmitted in such a way that may be beyond our control. Accordingly, we make
            no warranty concerning the delay, failure, interruption, or corruption of any data,
            the Content, the User Content or any other information transmitted in connection with
            the use of the Services.
            <strong>
              {' '}
              YOU EXPRESSLY AGREE THAT YOUR USE OF THE SERVICES IS AT YOUR SOLE RISK. THE
              SERVICES, THE CONTENT, AND THE USER CONTENT ARE PROVIDED “AS IS” AND “AS AVAILABLE”
              FOR YOUR USE, WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, UNLESS
              THESE WARRANTIES ARE LEGALLY INCAPABLE OF EXCLUSION. WE MAKE NO REPRESENTATIONS OR
              WARRANTIES THAT THE SERVICES, THE CONTENT, THE USER CONTENT, OR ANY SERVICES OR
              FEATURES OFFERED IN CONNECTION WITH THE SERVICES ARE OR WILL REMAIN UNINTERRUPTED OR
              ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE WEB PAGES ACCESSIBLE ON OR
              THROUGH THE SERVICES, OR THE SERVERS USED IN CONNECTION WITH THE SERVICES, ARE OR
              WILL REMAIN FREE FROM ANY VIRUSES, WORMS, TIME BOMBS, DROP DEAD DEVICES, TROJAN
              HORSES, OR OTHER HARMFUL COMPONENTS. WE DO NOT GUARANTEE THAT YOU WILL BE ABLE TO
              ACCESS OR USE THE SERVICES AT TIMES OR LOCATIONS OF YOUR CHOOSING, OR THAT WE WILL
              HAVE ADEQUATE CAPACITY FOR THE SERVICES AS A WHOLE OR IN ANY SPECIFIC GEOGRAPHIC
              AREA. WE MAKE NO REPRESENTATION OR WARRANTY REGARDING GOVERNMENT COMPLIANCE OF ANY
              SOFTWARE USED IN RUNNING THE SERVICES. YOU ARE SOLELY RESPONSIBLE FOR ALL OF YOUR
              COMMUNICATIONS AND INTERACTIONS WITH OTHER PERSONS AND PARTIES WITH WHOM YOU
              COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE SERVICES (E.G., THIRD PARTY
              PROVIDERS, RESTAURANTS, PEOPLE). YOU UNDERSTAND THAT CHIMEABLE DOES NOT TAKE
              RESPONSIBILITY FOR SCREENING OR INQUIRY INTO THE BACKGROUND OF ANY USERS OF THE WEB
              PROPERTIES, NOR DOES CHIMEABLE VERIFY OR TAKE RESPONSIBILITY FOR THE STATEMENTS,
              ADVICE OR RECOMMENDATIONS OF ANY SUCH USERS OF THE WEB PROPERTIES THAT MAY BE POSTED
              ONLINE. YOU ACKNOWLEDGE THAT CHIMEABLE IS NOT LIABLE TO YOU OR ANY PERSON FOR ANY
              DECISION MADE OR ACTION TAKEN IN RELIANCE UPON THE INFORMATION INCLUDED IN THE
              SERVICES AND CHIMEABLE IS NOT LIABLE TO ANY USER OR PERSON FOR ANY HARM CAUSED BY
              THE NEGLIGENCE OR MISCONDUCT OF ANY THIRD PARTY (INCLUDING, WITHOUT LIMITATION, A
              THIRD-PARTY PROVIDER), WHETHER OR NOT RELYING UPON INFORMATION COLLECTED, GENERATED,
              OR STORED VIA THE SERVICES.
            </strong>{' '}
          </li>
          <li>
            <strong>
              Indemnification: You agree to defend, indemnify, and hold harmless Chimeable and our
              directors, officers, employees, agents, successors and assigns from and against any
              and all claims, demands, suits, proceedings, liabilities, judgments, losses,
              damages, expenses, and costs (including, but not limited to, reasonable attorneys’
              fees) assessed or incurred by us, directly or indirectly, with respect to or arising
              out of: (i) your failure to comply with these Terms; (ii) your breach of your
              obligations under these Terms; (iii) your use of the rights granted hereunder,
              including, but not limited to, any claims made by any third parties against
              Chimeable as a result of your use of the Services; and/or (iv) any claim that your
              User Content caused damage to or violated the rights of a third party.
            </strong>
          </li>
          <li>
            <strong>Your Responsibilities:</strong> You are responsible for establishing such
            procedures as you deem appropriate to verify the accuracy of data that you transmit
            using the Services, and we will have no obligation to verify the accuracy of that
            data. While we reserve the right to review any and all User Content made available
            through the Services, you will remain responsible for your User Content. Your use of
            the Services is subject to the additional disclaimers and caveats that may appear
            throughout the Services. Chimeable is not responsible for an individual’s submissions,
            the quality of critiques and other actions of individual users.
          </li>
          <li>
            <strong>Network Access and Devices:</strong>
            You are responsible for obtaining the data network access necessary to use the
            Services. If you are accessing the Services on your mobile device, your network’s data
            and messaging rates and fees may apply. You are responsible for acquiring and updating
            compatible hardware or devices necessary to access and use the Services and any
            updates thereto. We do not guarantee that the Services, or any portion thereof, will
            function on any particular hardware or devices. In addition, all Services may be
            subject to malfunctions and delays inherent in the use of the Internet and electronic
            communications.
          </li>
        </ul>
        <h2 className="card-subtitle mb-2 text-muted text-black">12.Limitation of Liability. </h2>
        <p>
          IN NO EVENT WILL CHIMEABLE, OR ANY OF CHIMEABLE’S AFFILIATES, OR ANY OF CHIMEABLE’S
          RESPECTIVE OFFICERS, DIRECTORS, AGENTS, SUCCESSORS, ASSIGNS, PARENTS, SUBSIDIARIES OR
          OTHER REPRESENTATIVES, BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
          EXEMPLARY, PUNITIVE, OR CONSEQUENTIAL DAMAGES OF ANY KIND ARISING FROM YOUR USE OF OR
          INABILITY TO USE THE SERVICES, THE CONTENT, AND/OR THE USER CONTENT PROVIDED IN
          CONNECTION WITH THE SERVICES, OR FOR ANY OTHER CLAIM RELATED IN ANY WAY TO YOUR USE OF
          THE SERVICES, THE CONTENT AND/OR ANY USER CONTENT PROVIDED ON OR THROUGH THE SERVICES.
          IN ADDITION, WE WILL NOT BE LIABLE FOR ANY NEGATIVE REPERCUSSIONS TO ANYONE BASED ON THE
          USE OF OR INABILITY TO USE THE SERVICES, INCLUDING, BUT NOT LIMITED TO, ANY LOST
          GOODWILL, LOST PROFITS OR LOST REVENUES. WE ARE NOT LIABLE FOR ANY PERSONAL INJURY,
          INCLUDING DEATH, OR PROPERTY DAMAGE CAUSED BY YOUR USE OR MISUSE OF THE SERVICES AND/OR
          ANY CONTENT. WE ARE NOT RESPONSIBLE FOR: (A) INACCURACIES OR ERRORS IN OR OMISSIONS FROM
          THE CONTENT; (B) DELAYS, ERRORS, OR INTERRUPTIONS IN THE TRANSMISSION OR DELIVERY OF THE
          CONTENT; OR (C) LOSS OR DAMAGE ARISING THEREFROM OR OCCASIONED THEREBY, OR BY ANY REASON
          OF NONPERFORMANCE. REMEDIES UNDER THESE TERMS ARE EXCLUSIVE AND ARE LIMITED TO THOSE
          EXPRESSLY PROVIDED FOR IN THESE TERMS. TO THE FULLEST EXTENT PERMITTED BY APPLICABLE
          LAW, OUR ENTIRE LIABILITY SHALL BE LIMITED TO THE AMOUNT PAID BY YOU FOR THE SERVICES
          YOU RECEIVE USING THE SERVICES AND THE CONTENT. BECAUSE SOME STATES AND JURISDICTIONS DO
          NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL
          DAMAGES, IN SUCH STATES OR JURISDICTIONS, OUR LIABILITY WILL BE LIMITED TO THE GREATEST
          EXTENT PERMITTED BY APPLICABLE LAW. THESE TERMS GIVE YOU SPECIFIC LEGAL RIGHTS. YOU MAY
          ALSO HAVE OTHER RIGHTS THAT MAY VARY FROM ONE STATE OR JURISDICTION TO ANOTHER.
        </p>

        <h2 className="card-subtitle mb-2 text-muted text-black">
          13.Content Disclosure Guidelines.
        </h2>
        <p>
          As a participant in Chimeable programs—including but not limited to ChimeBox (free
          product sampling) and Digital Activations (reimbursement via Chimeable Cash rewards)—you
          are required to clearly and conspicuously disclose any material connection between
          yourself, Chimeable, and its brand partners in accordance with the Federal Trade
          Commission’s (“FTC”) Endorsement Guides and the policies of social media platforms on
          which content is shared.
        </p>
        <p>
          A “material connection” includes, but is not limited to, receiving free products,
          monetary reimbursement, or any other form of compensation (including Chimeable Cash
          rewards) in exchange for creating and sharing content.
        </p>
        <p>
          You must follow the requirements outlined below when publishing any review, video,
          image, post, or other form of user-generated content (“Content”) relating to your
          participation in Chimeable programs.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">
          a. General Disclosure Requirements
        </h4>
        <p>All disclosures must be:</p>
        <ul>
          <li>Clear: Written in plain and straightforward language.</li>
          <li>
            Conspicuous: Easily noticeable and not buried within other text or obscured by
            hashtags or links.
          </li>
          <li>
            Prominent and Unavoidable: Placed at the beginning of captions, posts, or
            descriptions, not at the end or hidden behind “more” links.
          </li>
          <li>
            Consistent Across Media: Disclosed in both audio and visual formats when content is
            presented via video.
          </li>
          <li>
            Sufficiently Displayed: On-screen disclosures in video must remain visible for a
            minimum of three (3) seconds, or long enough for an average viewer to read and
            understand the statement.
          </li>
        </ul>
        <h4 className="card-subtitle mb-2 text-muted text-black">b. Sample Disclosures</h4>
        <p>Participants may use one of the following approved examples or equivalent language:</p>
        <ul>
          <li>
            For ChimeBox Campaigns (free product):
            <p>
              “I received this product for free from @Chimeable and @[Brand] in exchange for my
              honest review.”
            </p>
          </li>
          <li>
            For Digital Activations (Chimeable Cash reward reimbursement):
            <p>
              “I received a Chimeable Cash reward from @Chimeable and @[Brand] for purchasing this
              product and sharing my honest opinion.”
            </p>
          </li>
        </ul>
        <p>
          The use of hashtags such as #gifted, #ad, or #sponsored may accompany disclosures but
          are not a substitute for a complete sentence disclosing the material connection.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">
          c. Platform-Specific Requirements
        </h4>
        <p>
          Participants are responsible for adhering to disclosure practices as required by
          individual platforms. This includes but is not limited to:
        </p>
        <ul>
          <li>
            Instagram and Facebook: Disclosures must appear in the first 125 characters of
            captions and must be shown visually in Stories or Reels. Disclosures should also be
            spoken aloud in videos. Participants must also adhere to Meta’s branded content
            policies, including use of its “Paid Partnership” tag. See Instagram’s guidance
            <a href="https://help.instagram.com/1123581461537025" rel="nofollow">
              {' '}
              <u>here</u>.
            </a>
          </li>
          <li>
            TikTok: Disclosures must be included early in captions and shown visually in videos.
            Disclosures must also be spoken when possible. Participants must comply with TikTok’s
            branded content rules, which may include flagging content as branded or sponsored. See
            TikTok’s policy
            <a
              href="https://support.tiktok.com/en/business-and-creator/creator-and-business-accounts/promoting-a-brand-product-or-service"
              rel="nofollow"
            >
              {' '}
              <u>here.</u>
            </a>
          </li>
          <li>
            YouTube and Blogs: Disclosure must be included in the first 125 characters of the
            description and spoken and shown within the first 30 seconds of video content or at
            the beginning of the blog post.
          </li>
          <li>
            Retail and External Reviews: If the review platform does not include a checkbox for
            indicating receipt of a free product, the disclosure must be written as the first
            sentence of the review.
          </li>
        </ul>
        <h4 className="card-subtitle mb-2 text-muted text-black">d. FTC Compliance</h4>
        <p>
          All participants are required to follow the FTC’s Endorsement Guides. For full details,
          please review the FTC’s official
          <a
            href="https://www.ftc.gov/business-guidance/resources/ftcs-endorsement-guides-what-people-are-asking"
            rel="nofollow"
          >
            {' '}
            <u>guidance.</u>
          </a>
          {' '}
          Failure to comply with these guidelines may result in disqualification from current or
          future Chimeable programs and may expose the participant to legal liability under FTC
          regulations. If you are unsure whether a disclosure is required or how to properly
          phrase it, please contact Chimeable at support@chimeable.com before publishing any
          content.
        </p>

        <h2 className="card-subtitle mb-2 text-muted text-black">
          14.Third Party Content and Third Party Applications.{' '}
        </h2>
        <p>
          We may provide hyperlinks to other websites maintained by third parties, or we may
          provide third party content on the Services by framing or other methods (collectively,
          “Third Party Content”). In addition, the Services may include certain applications,
          features, programs and services provided by third parties (collectively, “Third Party
          Applications”). We do not monitor Third Party Content or Third Party Applications and
          can make no guarantee as to the accuracy or completeness of such Third Party Content or
          Third Party Applications.  The links to third party websites, any Third Party Content,
          and any Third Party Applications are provided for your convenience and information only.
          The content on any linked website or in any Third Party Application is not under our
          control and we are not responsible for the content of linked websites and/or Third Party
          Applications, including any further links contained in a third party website. We make no
          representation or warranty in connection with any Third Party Content or Third Party
          Application, which at all times and in each instance is provided “as is.” If you decide
          to access any of the third party websites linked to the Services, any Third Party
          Content, and/or any Third Party Application, you do so entirely at your own risk. If a
          third party links or refers to the Services, it is not necessarily an indication of an
          endorsement, authorization, sponsorship, affiliation, joint venture, or partnership by
          or with us. In most cases, we are not even aware that a third party has linked to or
          refers to the Services.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">15.Intellectual Property. </h2>
        <p>
          The Content provided through the Services is intellectual property owned, controlled
          and/or licensed by us and/or our affiliates, or intellectual property that we are
          legally permitted to access and use. All applicable intellectual property laws,
          including copyright laws, protect our rights in and to the Content. No portion of the
          Content and/or User Content may be reproduced in any form or by any means, except as
          provided in these Terms. We are the owner or authorized licensee of, or are otherwise
          permitted to use, all trademarks, service marks, and logos used and displayed by us on
          the Services. All trademarks and service marks of Chimeable that may be referred to on
          the Services are the property of Chimeable or one of our affiliates. Other parties’
          trademarks and service marks that may be referred to on the Services are the property of
          their respective owners. Nothing on the Services should be construed as granting, by
          implication, estoppel, or otherwise, any license or right to use any of our, or our
          affiliates’, trademarks, service marks, logos, or copyrighted materials without our
          prior written permission.{' '}
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">16.Copyright Complaints. </h2>
        <p>
          {' '}
          We own, protect and enforce copyright and other rights in our own intellectual property,
          and respect the intellectual property rights of others. We will respond to allegations
          of copyright infringement in accordance with the Digital Millennium Copyright Act (the
          “DMCA”). Under the DMCA, a copyright owner may file a takedown notice with an online
          service provider of an alleged copyright infringement. During this process, the service
          provider responds by taking down the alleged infringing content, and takes reasonable
          steps to contact the owner of the removed content so that a counter-notification may be
          filed, if appropriate. If a valid counter-notification is filed, we typically will
          restore the content in question, unless we receive notice from the notification provider
          that a legal action has been filed seeking a court order to restrain the alleged
          infringer from engaging in the infringing activity. We may provide copies of such
          notices to the affected parties or to any other third parties, at our discretion and as
          required by law. Our Privacy Policy does not apply to any information contained in these
          notices. When notifying us of potential infringement, you must include the following:
        </p>
        <ul>
          <li>
            identification of the copyrighted work(s) claimed to have been infringed. If multiple
            copyrighted works are involved, then a representative list of those works on the
            Services;
          </li>
          <li>identification of the allegedly infringing material that is to be removed;</li>
          <li>
            information reasonably sufficient to permit us to locate the allegedly infringing
            material on the Services;
          </li>
          <li>
            contact information reasonably sufficient to permit us to contact the complaining
            party, such as an address, telephone number, or email address;
          </li>
          <li>
            a statement that the complaining party has a good faith belief that use of the
            material is in fact infringing and not authorized by the copyright owner, its agent,
            or the law;
          </li>
          <li>
            a statement, made under penalty of perjury, that the information set forth in the
            notification is accurate and, where relevant, that the complaining party is authorized
            to act on behalf of the copyright owner; and{' '}
          </li>
          <li>
            the signature, physical or electronic, of the copyright owner or a person authorized
            to act on his or her behalf.
          </li>
          <p>
            A provider of content subject to a claim of infringement may make a
            counter-notification. To file a counter-notification with us, please provide the DMCA
            Agent with a written communication containing the following:
          </p>
          <ul>
            <li>
              identification of the allegedly infringing material that was removed or disabled;
            </li>
            <li>
              a statement that, under penalty of perjury, you have a good faith belief that the
              material was removed or disabled as a result of mistake or misidentification of the
              material to be removed or disabled;
            </li>
            <li>
              your name, address, and telephone number, and a statement that you consent to the
              jurisdiction of the Federal District Court for the judicial district in which your
              postal address is located, and that you will accept service of process from the
              party who submitted the infringement notification or his, her, or its principal or
              agent; and
            </li>
            <li>
              the signature, physical or electronic, of you or a person authorized to act on your
              behalf.
            </li>
          </ul>
          <p>
            We will promptly provide the party that provided the notice of alleged infringement
            with a copy of the counter-notification, and inform the complaining party that we
            intend to restore the removed or disabled content within ten (10) business days. If we
            do not receive notice that a lawsuit has been filed within ten (10) business days
            after we provide notice of the counter-notification, we will restore the removed or
            disabled content. Until that time, your content will remain removed or disabled.
          </p>
          <p>
            Notice of alleged infringement must be sent by electronic mail to our DMCA Agent,
            contact@chimeable.com, or by certified mail and marked “Copyright Infringement”, Attn:
            DMCA Agent 175 Mt Aeolus Ln Manchester VT, 05255{' '}
          </p>
          <p>
            Before filing notice of copyright infringement, you must make a careful determination
            as to whether or not the use of the material at issue is or may be protected by the
            “fair use” doctrine. You could potentially be held liable for costs and attorneys’
            fees should you file a takedown notice where there is no infringing use. If you are
            unsure whether there is infringement, it may be advisable to seek legal counsel.{' '}
          </p>
        </ul>
        <h2 className="card-subtitle mb-2 text-muted text-black">17.Termination of Service.</h2>
        <p>
          We may suspend or terminate your right to access portions of the Services at any time,
          without notice, for conduct that we believe violates these Terms and/or is harmful to
          other users of the Services, to us, to our partners, to the contributors, to the
          business of our Internet service provider, or to other information providers, or as we
          otherwise deem appropriate, in our sole discretion.{' '}
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">18.Additional Remedies.</h2>
        <p>
          You acknowledge that your conduct that is inconsistent with these Terms may cause us
          irreparable damage for which remedies other than monetary relief may be inadequate. In
          such instances, you agree that we may seek injunctive or other equitable relief to
          restrain such conduct without the necessity of proving actual harm or posting a bond.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">19.Local Laws.</h2>
        <p>
          We make no representation that any Content or materials on the Services are appropriate
          or available for use in jurisdictions that are outside the United States. Access to the
          Services from jurisdictions where such access is illegal is prohibited. If you choose to
          access the Services from other jurisdictions, you do so at your own initiative and are
          responsible for compliance with applicable local laws.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">
          20.Governing Law; Jurisdiction and Venue.
        </h2>
        <p className="card-text">
          {' '}
          We will try to work in good faith to resolve any issue you have with the Services, if
          you bring that issue to the attention of our customer service department. However, we
          realize that there may be rare cases where we may not be able to resolve an issue to a
          customer's satisfaction.
        </p>
        <p>
          You and Chimeable agree that any dispute, claim, or controversy arising out of or
          relating in any way to these Terms or your use of the Services, shall be determined by
          binding arbitration instead of in courts of general jurisdiction. Arbitration is more
          informal than bringing a lawsuit in court. Arbitration uses a neutral arbitrator instead
          of a judge or jury, and is subject to very limited review by courts. Arbitration allows
          for more limited discovery than in court, however, we agree to cooperate with each other
          to agree to reasonable discovery in light of the issues involved and amount of the
          claim. Arbitrators can award the same damages and relief that a court can award, but in
          so doing, the arbitrator shall apply substantive law regarding damages as if the matter
          had been brought in court, including without limitation, the law on punitive damages as
          applied by the United States Supreme Court. You agree that, by agreeing to these Terms,
          the U.S. Federal Arbitration Act governs the interpretation and enforcement of this
          provision, and that you and Chimeable are each waiving the right to a trial by jury or
          to participate in a class action. This arbitration provision shall survive termination
          of these Terms. If you desire to assert a claim against Chimeable, and you therefore
          elect to seek arbitration, you must first send to Chimeable, by certified mail, a
          written notice of your claim ("Notice"). The Notice to Chimeable should be addressed to:
          Chimeable 175 Mt Aeolus Ln Manchester VT, 05255 ("Notice Address"). During the
          arbitration, the amount of any settlement offer made by Chimeable or you shall not be
          disclosed to the arbitrator. You may download or copy a form Notice and a form to
          initiate arbitration from the American Arbitration Association at www.adr.org . The
          arbitration will be governed by the Commercial Arbitration Rules and the Supplementary
          Procedures for Consumer Related Disputes (collectively, "AAA Rules") of the American
          Arbitration Association ("AAA"), as modified by these Terms, and will be administered by
          the AAA. The AAA Rules and Forms are available online at www.adr.org , by calling the
          AAA at 1-800-778-7879, or by requesting them from us by writing to us at the Notice
          Address. The arbitrator is bound by the terms of these Terms. All issues are for the
          arbitrator to decide, including issues relating to the scope and enforceability of these
          Terms, including this arbitration agreement. Unless Chimeable and you agree otherwise,
          any arbitration hearings will take place in the State of Delaware. The arbitrator shall
          issue a reasoned written decision sufficient to explain the essential findings and
          conclusions on which the award is based. If the arbitrator issues you an award that is
          greater than the value of Chimeable’s last written settlement offer made before an
          arbitrator was selected (or if Chimeable did not make a settlement offer before an
          arbitrator was selected), then Chimeable will pay you the amount of the award. Except as
          expressly set forth herein, the payment of all filing, administration and arbitrator
          fees will be governed by the AAA Rules. Each party shall pay for its own costs and
          attorneys' fees, if any.{' '}
        </p>
        <p>
          <strong>
            YOU AND CHIMEABLE AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR
            ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS
            OR REPRESENTATIVE PROCEEDING.
          </strong>
          Further, unless both you and Chimeable agree otherwise, the arbitrator may not
          consolidate more than one person's claims with your claims, and may not otherwise
          preside over any form of a representative or class proceeding. The arbitrator may award
          declaratory or injunctive relief only in favor of the individual party seeking relief
          and only to the extent necessary to provide relief warranted by that party's individual
          claim. If this Agreement to Arbitrate provision is found to be unenforceable, then (a)
          the entirety of this arbitration provision shall be null and void, but the remaining
          provisions of these Terms shall remain in full force and effect; and (b) exclusive
          jurisdiction and venue for any claims will be in state or federal courts located in the
          State of Delaware. Both Chimeable and you agree to waive any and all rights to a jury
          trial in the event this agreement to arbitrate is found to be unenforceable. Nothing
          herein shall prevent either party from seeking injunctive relief or specific performance
          in any court of competent jurisdiction. If Chimeable seeks injunctive relief or specific
          performance, it shall not be required to post a bond or similar undertaking.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">21.Export Restrictions.</h2>
        <p>
          Any software and all underlying information and technology downloaded or viewed from any
          of the Services or in connection with the services (collectively, the “Software or
          Technical Data”) by you may be subject to U.S. export controls, including the Export
          Administration Act and the Export Administration Regulations, and may be subject to
          export or import regulations in other countries. You are solely responsible for
          complying with all trade regulations and laws, both foreign and domestic, in your use
          and viewing of the Services, the Content, the User Content, and any of our products or
          services, including, but not limited to, the Software or Technical Data. Except as
          authorized by law, you agree and warrant not to export or re-export the Software or
          Technical Data to any county, or to any person, entity, or end-user subject to U.S.
          export controls, including, but not limited to, persons or entities listed on the U.S.
          Department of Commerce Bureau of Export Administration's Denied Parties List and the
          U.S. Department of Treasury's Specially Designated Nationals. You further represent and
          warrant that no U.S. federal agency has suspended, revoked, or denied your export
          privileges.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black text-black">22.Comments</h2>
        <p>
          By submitting comments, information or feedback (collectively, “Feedback”) to us via the
          phone, through email and/or the Services, you agree that the information submitted will
          be subject to our Privacy Policy. We may use Feedback in any manner that we may choose,
          including, but not limited to, the incorporation of suggested changes into our services
          and products, without notice or compensation to you.{' '}
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <p>
            <strong>Your Consent To These Terms of Service </strong>
          </p>
        </div>
        <p>
          By accessing and using the Services, you consent to and agree to be bound by these
          Terms. If we decide to change these Terms or some part of them, we will make an effort
          to post those changes on this web page so that you will always be able to understand and
          agree to the terms and conditions governing your use of the Services. Your use of the
          Services following your acceptance of any amendment of these Terms will signify your
          assent to and acceptance of the revised Terms for all previously collected information
          and information collected from you in the future. If you have additional questions or
          comments of any kind, or if you see anything on the Services that you think is
          inappropriate, please let us know by sending your comments or requests to:
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <p>Chimeable Inc.</p>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <p>175 Mt Aeolus Ln Manchester VT, 05255</p>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <p> Copyright © 2025. Chimeable Inc.</p>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <p> All Rights Reserved.</p>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <p> Last updated: March 22, 2025</p>
        </div>
        {
          /*
           * END HTML
           */
        }

      </div>
    </Layout>
  );
};

export default Terms;